@if (loader.loading$ | async) {
<spinner />
}
<router-outlet />
